<header
  clientSideOnly
  #header
  class="fixed z-30 w-full top-0 ltr:left-0 rtl:right-0 pt-[28px] lg-custom:pt-6 transition-all duration-300 lg-custom:duration-500 animate-[slideInDown_0.6s_0.5s_ease_both]"
  [class.sticky-header]="isStickyEnabled"
  [class.menu-enabled]="isMobileMenuEnabled"
  [ngClass]="pageType"
>
  <div
    *ngIf="isDataReady"
    class="header-bg z-[-1] ltr:left-[-100vw] ltr:lg-custom:left-0 rtl:right-[-100vw] rtl:lg-custom:right-0 top-0 absolute w-full h-full border-b border-solid border-transparent"
  ></div>
  <nav *ngIf="isDataReady" class="max-w-large-desktop mx-auto top-header">
    <div class="px-10 mx-auto lg-custom:flex lg-custom:items-center">
      <div
        class="hidden lg-custom:flex flex-col lg-custom:flex-row ltr:lg-custom:ml-auto rtl:lg-custom:mr-auto mt-3 lg-custom:mt-0 gap-[34px] items-center"
        id="navbar-collapse"
        [ngClass]="userData?.siteUsersID && userWalletAmmount?.isSuccess && !currentBalanceStopped && !currentBalanceLoading ? 'topupexist' : ''"
      >
        <div class="flex gap-2">
          <ng-container *ngFor="let link of topLinks">
            <a
              *ngIf="link.href; else linkCase"
              [href]="link.href"
              (click)="closeMobileMenu()"
              class="top-menu-item after:content-normal last:after:hidden flex gap-3 items-center justify-center after:w-px after:h-1/2 after:bg-white hover:opacity-80 transition-all"
            >
              <ng-container
                *ngTemplateOutlet="linkContent; context: { link: link }"
              ></ng-container>
            </a>
            <ng-template #linkCase>
              <a
                [routerLink]="link.link | routeLocalization"
                class="top-menu-item after:content-normal last:after:hidden flex gap-3 items-center justify-center after:w-px after:h-1/2 after:bg-white hover:opacity-80 transition-all"
                (click)="closeMobileMenu()"
              >
                <ng-container
                  *ngTemplateOutlet="linkContent; context: { link: link }"
                ></ng-container>
              </a>
            </ng-template>
          </ng-container>
        </div>

        <!-- <div class="flex flex-row " *ngIf="isAuth"> -->
        <div class="flex flex-row" *ngIf="userData?.siteUsersID && userWalletAmmount?.isSuccess && !currentBalanceStopped && !currentBalanceLoading">
          <div
            class="bg-[#009933] transform ltr:skew-x-[-30deg] rtl:skew-x-[30deg] h-[30px]"
          >
            <div class="ltr:skew-x-[30deg] rtl:skew-x-[-30deg]">
              <p
                (click)="isModalEnabled = true;inputValue = '';isSubmitted=false;"
                class="px-5 py-1 tracking-normal text-center underline font-Poppins-Light text-base leading-[25px] text-white cursor-pointer -mt-0.5"
              >
                {{ "DASHBOARD.TOPUP" | translate }}
              </p>
            </div>
          </div>

          <div
            class="bg-[#003399] ltr:skew-x-[-30deg] rtl:skew-x-[30deg] h-[30px]"
          >
            <div
              class="ltr:skew-x-[30deg] rtl:skew-x-[-30deg] flex flex-row gap-3 px-3 items-center"
            >
              <p
                class="py-1 tracking-normal font-semibold text-lg text-white mt-[-3px] min-w-[59px]"
              >
                {{ "CURRENCIES.QR" | translate }}
               
                  {{ isIconClicked ? formattedAmount : maskedAmount }}
              </p>
               <!-- {{ isIconClicked ? userWalletAmmount?.result : "***" }} -->
              <app-svg
                (click)="toggleIcon()"
                textClass=""
                src="assets/svgs/{{
                  isIconClicked ? 'eye-closed.svg' : 'eye-svgrepo.svg'
                }}"
                customClass="mt-[-3px] flex items-center cursor-pointer"
                label="title_goes_here"
                [stretch]="false"
                width="24"
                height="24"
                stroke="#fff"
              ></app-svg>
            </div>
          </div>
        </div>
        <!-- <div *ngIf="userData?.siteUsersID && !userWalletAmmount?.isSuccess">
          <app-btn-one link="/woqode-tag" text="popup.Register" textClass="font-Cairo-Regular text-base py-0.5"
            seoDesc="Text about the button" svg="assets/svgs/arrow.svg" svgClass="rotate-[270deg]"></app-btn-one>
        </div> -->
        <div class="relative flex gap-[18px] items-center">
          <button
            type="button"
            id="login-btn"
            aria-label="login"
            class="button-wraper flex justify-center items-center relative float-left z-10 tracking-[-0.5px] text-white font-Poppins-Light text-sm w-[18px] h-[18px]"
            data-element-scale="1.5"
            *ngIf="!userData?.siteUsersID"
            (click)="login()"
          >
            <div class="button-wraper-inner outline-none">
              <app-svg
                src="assets/svgs/user-new-white.svg"
                label="Login"
                [stretch]="false"
                width="22"
                height="22"
                fill="#ffffff"
                viewBox="auto"
              ></app-svg>
            </div>
          </button>

          <div appClickOutSide (appOutsideClick)="!isMobile ? (isUserMenuEnabled = false) : (null)" class="h-[40px]">
          <!-- <div appClickOutSide (appOutsideClick)="isUserMenuEnabled = false;"> -->
                      <button
            *ngIf="userData?.siteUsersID"
            type="button"
            (click)="isUserMenuEnabled = !isUserMenuEnabled"
            id="user_btn"
            aria-label="profile"
          >
            <img
              [src]="getUserImage() | imageSource"
              class="w-10 h-10 bg-[#ECECEE] border border-solid border-[#009933] rounded-full"
              alt="User Image"
            />
          </button>

          <div
            *ngIf="isUserMenuEnabled"
            class="absolute top-[46px] ltr:right-[85px] rtl:left-[85px] w-[338px] h-auto bg-white z-[100] rounded-lg shadow-custom-6"
          >
            <div class="mt-11 mb-5 mx-auto relative">
              <img
                class="w-[82px] mx-auto h-[82px] bg-[#ECECEE] border-2 border-solid border-[#009933] rounded-full"
                [src]="getUserImage() | imageSource"
                alt="User Image"
              />
              <div
                class="absolute rounded-full flex justify-center items-center left-0 mx-auto ltr:right-[-55px] rtl:right-[55px] -bottom-2.5 bg-[#CCCCCC] w-[30px] h-[30px] border-2 border-solid border-white custom-7"
              >
                <app-svg
                  src="assets/svgs/arrow.svg"
                  label="title_goas_here"
                  [stretch]="false"
                  width="24"
                  height="24"
                  stroke="#ffffff"
                ></app-svg>
              </div>
            </div>
            <div class="px-[22px]">
              <p
                class="text-center -mt-2.5 font-Poppins-Medium text-lg text-black whitespace-normal leading-[1.5]"
                *ngIf="userData?.siteUsersID"
              >
                {{ getFullName() }}
              </p>
              <hr class="border-t-[#E0E0E0] mt-3 mb-[22px]" />
              <ul class="flex flex-col gap-3">
                <ng-container *ngFor="let item of userMenu">
                <li
                  *ngIf="(item.link !== '/dashboard/my-wallet') || (item.link === '/dashboard/my-wallet' && userWalletAmmount?.isSuccess && !currentBalanceLoading && !currentBalanceStopped)"
                  class="flex justify-between gap-2 cursor-pointer"
                  (click)="clickOnMenuItem()"
                  [routerLink]="item.link | routeLocalization"
                >
                  <div class="flex gap-3 items-center">
                    <app-svg
                      [src]="item.svg"
                      customClass=""
                      label="title_goas_here"
                      [stretch]="false"
                      width="24"
                      height="24"
                      [fill]="item.fill"
                    ></app-svg>
                    <span
                      class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                      >{{ item.title | translate }}</span
                    >
                  </div>
                  <app-svg
                    src="assets/svgs/arrow.svg"
                    customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                    label="title_goas_here"
                    [stretch]="false"
                    width="24"
                    height="24"
                    stroke="#000000"
                  ></app-svg>
                </li>
                </ng-container>
                    <li *ngIf="currentBalanceLoading">
                      <div class="w-4 h-4 border-2 border-gray-300 border-t-transparent rounded-full animate-spin mx-auto"></div>                      
                    </li>                
                     <li *ngIf="!userWalletAmmount?.isSuccess && !currentBalanceStopped && !currentBalanceLoading"
                       class="flex justify-between gap-2 cursor-pointer"
                       (click)="clickOnMenuItem()"
                       [routerLink]="'/woqode-tag' | routeLocalization"
                     >
                       <div class="flex gap-3 items-center">
                        <img src="assets/images/woqode.png" alt="" class="w-6 h-6" />
                         <!-- <app-svg
                           [src]="item.svg"
                           customClass=""
                           label="title_goas_here"
                           [stretch]="false"
                           width="24"
                           height="24"
                           [fill]="item.fill"
                         ></app-svg> -->
                         <span
                           class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                           >{{ 'Become_a_WOQOD_customer' | translate }}</span
                         >
                       </div>
                       <app-svg
                         src="assets/svgs/arrow.svg"
                         customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                         label="title_goas_here"
                         [stretch]="false"
                         width="24"
                         height="24"
                         stroke="#000000"
                       ></app-svg>
                     </li>
              </ul>
              <hr class="border-t-[#E0E0E0] mt-2.5 lg:mt-2.5 mb-3" />
              <ul class="flex flex-col gap-3 mb-3">
                <li
                  class="flex justify-between gap-2 cursor-pointer"
                  (click)="logout()"
                >
                  <div class="flex gap-3 items-center">
                    <app-svg
                      src="assets/svgs/logout.svg"
                      customClass=""
                      label="title_goas_here"
                      [stretch]="false"
                      width="24"
                      height="24"
                      fill="#000000"
                    ></app-svg>
                    <span
                      class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                      >{{ "DASHBOARD.LOG_OUT" | translate }}</span
                    >
                  </div>
                  <app-svg
                    src="assets/svgs/arrow.svg"
                    customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                    label="title_goas_here"
                    [stretch]="false"
                    width="24"
                    height="24"
                    stroke="#000000"
                  ></app-svg>
                </li>
              </ul>
            </div>
          </div>

          </div>
          <app-lang-switcher
            [isEn]="isEn"
            (toggleLanguage)="setLang()"
            [class.pointer-events-none]="isChangeLangBtnDisabled"
          ></app-lang-switcher>
        </div>
      </div>
    </div>
  </nav>
  <nav
    *ngIf="isDataReady"
    class="max-w-large-desktop mx-auto border-line-between"
  >
    <div
      class="px-10 mx-auto lg-custom:flex lg-custom:items-center gap-5 pb-[28px] lg-custom:pb-0"
    >
      <div class="flex justify-between items-center gap-4 lg-custom:gap-0">
        <div class="logo-container" aria-label="Home Page">
          <a [routerLink]="('/') | routeLocalization">
            <img
              *ngIf="pageType"
              (click)="closeMobileMenu()"
              [src]="logo[pageType][isStickyEnabled ? 'sticky' : 'normal']"
              class="-mt-1.5"
              [ngClass]="''"
              height=""
              alt="Logo"
              title="Logo"
            />
          </a>
        </div>
        <div class="flex gap-[18px] lg-custom:hidden items-center">
          <button
            type="button"
            id="login-btn"
            aria-label="login"
            class="button-wraper flex justify-center items-center relative float-left z-10 tracking-[-0.5px] text-white font-Poppins-Light text-sm w-[18px] h-[18px]"
            data-element-scale="1.5"
            *ngIf="!userData?.siteUsersID"
            (click)="login()"
          >
            <div class="button-wraper-inner outline-none">
              <app-svg
                src="assets/svgs/user-new-white.svg"
                label="Login"
                [stretch]="false"
                width="22"
                height="22"
                fill="#ffffff"
                viewBox="auto"
              ></app-svg>
            </div>
          </button>

          <div appClickOutSide (appOutsideClick)="isMobile ? (isUserMenuEnabled = false) : (null)" class="h-[40px]">
          <button
            *ngIf="userData?.siteUsersID"
            type="button"
            class="w-8 h-8"
            (click)="isUserMenuEnabled = !isUserMenuEnabled"
          >
            <img
              class="w-8 h-8 bg-[#ECECEE] border border-solid border-[#009933] rounded-full"
              [src]="getUserImage() | imageSource"
              alt="User Image"
            />
          </button>

          <div
            *ngIf="isUserMenuEnabled"
            class="absolute top-[68px] right-0 left-0 mx-auto w-[calc(100%-24px)] lg-custom:right-[unset] lg-custom:w-[338px] h-auto bg-white z-[100] rounded-lg shadow-custom-6"
          >
            <div class="mt-11 mb-5 mx-auto relative">
              <img
                class="w-[82px] mx-auto h-[82px] bg-[#ECECEE] border-2 border-solid border-[#009933] rounded-full"
                [src]="getUserImage() | imageSource"
                alt="User Image"
              />
              <div
                class="absolute rounded-full flex justify-center items-center left-0 mx-auto ltr:right-[-55px] rtl:right-[55px] -bottom-2.5 bg-[#CCCCCC] w-[30px] h-[30px] border-2 border-solid border-white custom-7"
              >
                <app-svg
                  src="assets/svgs/arrow.svg"
                  label="title_goas_here"
                  [stretch]="false"
                  width="24"
                  height="24"
                  stroke="#ffffff"
                ></app-svg>
              </div>
            </div>
            <div class="px-[22px]">
              <p
                class="text-center -mt-2.5 font-Poppins-Medium text-lg text-black whitespace-normal leading-[1.5]"
                *ngIf="userData?.siteUsersID"
              >
                {{ getFullName() }}
              </p>
              <hr class="border-t-[#E0E0E0] mt-3 mb-[22px]" />
              <ul class="flex flex-col gap-3">
                <ng-container *ngFor="let item of userMenu">
                <li
                *ngIf="(item.link !== '/dashboard/my-wallet') || (item.link === '/dashboard/my-wallet' && userWalletAmmount?.isSuccess && !currentBalanceLoading && !currentBalanceStopped)"
                  class="flex justify-between gap-2 cursor-pointer"
                  (click)="clickOnMenuItem()"
                  [routerLink]="item.link | routeLocalization"
                >
                  <div class="flex gap-3 items-center">
                    <app-svg
                      [src]="item.svg"
                      customClass=""
                      label="title_goas_here"
                      [stretch]="false"
                      width="24"
                      height="24"
                      [fill]="item.fill"
                    ></app-svg>
                    <span
                      class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                      >{{ item.title | translate }}</span
                    >
                  </div>
                  <app-svg
                    src="assets/svgs/arrow.svg"
                    customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                    label="title_goas_here"
                    [stretch]="false"
                    width="24"
                    height="24"
                    stroke="#000000"
                  ></app-svg>
                </li>
                  </ng-container>
                    <li *ngIf="currentBalanceLoading">
                      <div class="w-4 h-4 border-2 border-gray-300 border-t-transparent rounded-full animate-spin mx-auto"></div>                      
                    </li>
                     <li *ngIf="!userWalletAmmount?.isSuccess && !currentBalanceStopped && !currentBalanceLoading"
                       class="flex justify-between gap-2 cursor-pointer"
                       (click)="clickOnMenuItem()"
                       [routerLink]="'/woqode-tag' | routeLocalization"
                     >
                       <div class="flex gap-3 items-center">
                        <img src="assets/images/woqode.png" alt="" class="w-6 h-6" />
                         <!-- <app-svg
                           [src]="item.svg"
                           customClass=""
                           label="title_goas_here"
                           [stretch]="false"
                           width="24"
                           height="24"
                           [fill]="item.fill"
                         ></app-svg> -->
                         <span
                           class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                           >{{ 'Become_a_WOQOD_customer' | translate }}</span
                         >
                       </div>
                       <app-svg
                         src="assets/svgs/arrow.svg"
                         customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                         label="title_goas_here"
                         [stretch]="false"
                         width="24"
                         height="24"
                         stroke="#000000"
                       ></app-svg>
                     </li>
              </ul>
              <hr class="border-t-[#E0E0E0] mt-2.5 lg:mt-2.5 mb-3" />
              <ul class="flex flex-col gap-3 mb-3">
                <li class="flex justify-between gap-2"                   (click)="logout()">
                  <div class="flex gap-3 items-center">
                    <app-svg
                      src="assets/svgs/logout.svg"
                      customClass=""
                      label="title_goas_here"
                      [stretch]="false"
                      width="24"
                      height="24"
                      fill="#000000"
                    ></app-svg>
                    <span
                      class="ltr:text-left rtl:text-right font-Poppins-Light text-sm leading-5 text-[#221E20]"
                      >{{ "DASHBOARD.LOG_OUT" | translate }}</span
                    >
                  </div>
                  <app-svg
                    src="assets/svgs/arrow.svg"
                    customClass="ltr:rotate-[270deg] rtl:rotate-[90deg]"
                    label="title_goas_here"
                    [stretch]="false"
                    width="24"
                    height="24"
                    stroke="#000000"
                  ></app-svg>
                </li>
              </ul>
            </div>
          </div>
          </div>


          <div class="relative">
            <app-lang-switcher
              [isEn]="isEn"
              (toggleLanguage)="setLang()"
              [class.pointer-events-none]="isChangeLangBtnDisabled"
            ></app-lang-switcher>
          </div>

          <button
            type="button"
            aria-label="search over website"
            class="w-[24px] h-[24px]"
            (click)="closeMobileMenu(); isSearchModal = true"
          >
            <app-svg
              src="assets/svgs/search.svg"
              label="search over website"
              [stretch]="false"
              width="24"
              height="24"
            ></app-svg>
          </button>

          <button
            type="button"
            class="w-[24px] h-[24px]"
            (click)="toggleMobileMenu()"
            aria-label="toggle mobile menu"
            [class.mobileMenuEnabled]="isMobileMenuEnabled"
            aria-label="Menu Toggler"
          >
            <span class="block bg-white h-[2px] transition-all"></span>
            <span class="block bg-white h-[2px] transition-all my-1.5"></span>
            <span class="block bg-white h-[2px] transition-all"></span>
          </button>
        </div>
      </div>

      <div
        class="hidden lg-custom:flex flex-col lg-custom:flex-row ltr:lg-custom:ml-auto rtl:lg-custom:mr-auto mt-3 lg-custom:mt-0 w-full"
        id="navbar-collapse2"
      >
        <hr class="border-[0.5px] border-white w-full" />
      </div>
    </div>

    <div
      class="block lg-custom:hidden bg-[#003399] mobile-menu overflow-x-auto fixed w-full top-[87px] py-10 pl-[41px] pr-[43px] lg-custom:p-10 h-[calc(100vh-77px)] ltr:left-[-100vw] rtl:right-[-100vw] transition-all duration-300 lg-custom:duration-500 opacity-0"
    >
      <div class="min-h-[47.5px]" *ngIf="pageType && lang">
        <app-menu-item
          *ngFor="let menuItem of menuItems?.[pageType]?.[lang]; let i = index"
          [data]="menuItem"
          [id]="'menu-item-' + i"
          [isStickyEnabled]="isStickyEnabled"
          (closeMobileMenu)="closeMobileMenu($event)"
          [pageType]="pageType"
          [promotionList]="promotionList"
        ></app-menu-item>
      </div>
      <hr class="mb-8" />
      <div class="flex flex-col gap-3">
        <ng-container *ngFor="let link of topLinks">
          <a
            *ngIf="link.href; else linkCase"
            [href]="link.href"
            (click)="closeMobileMenu()"
            class="top-menu-item after:content-normal last:after:hidden flex gap-3 items-center justify-center after:w-px after:h-1/2 after:bg-white hover:opacity-80 transition-all"
          >
            <ng-container
              *ngTemplateOutlet="linkContent; context: { link: link }"
            ></ng-container>
          </a>
          <ng-template #linkCase>
            <a
              [routerLink]="link.link | routeLocalization"
              class="top-menu-item after:content-normal last:after:hidden flex gap-3 items-center justify-center after:w-px after:h-1/2 after:bg-white hover:opacity-80 transition-all"
              (click)="closeMobileMenu()"
            >
              <ng-container
                *ngTemplateOutlet="linkContent; context: { link: link }"
              ></ng-container>
            </a>
          </ng-template>
        </ng-container>

        <div class="flex flex-row" *ngIf="userData?.siteUsersID && userWalletAmmount?.isSuccess && !currentBalanceLoading && !currentBalanceStopped">
          <div
            class="bg-[#009933] transform ltr:skew-x-[-30deg] rtl:skew-x-[30deg] h-[30px]"
          >
            <div class="ltr:skew-x-[30deg] rtl:skew-x-[-30deg]">
              <p
                (click)="isModalEnabled = true; closeMobileMenu();inputValue = '';isSubmitted=false;"
                class="px-5 py-1 tracking-normal text-center underline font-Poppins-Light text-base leading-[25px] text-white cursor-pointer -mt-0.5"
              >
                {{ "DASHBOARD.TOPUP" | translate }}
              </p>
            </div>
          </div>

          <div
            class="bg-[#003399] ltr:skew-x-[-30deg] rtl:skew-x-[30deg] h-[30px]"
          >
            <div
              class="ltr:skew-x-[30deg] rtl:skew-x-[-30deg] flex flex-row gap-3 px-3 items-center"
            >
              <p
                class="py-1 tracking-normal font-Poppins-Bold text-lg text-white mt-[-3px] min-w-[59px]"
              >
                {{ "CURRENCIES.QR" | translate }}
                {{ isIconClicked ? (formatAmount(userWalletAmmount?.result) || 0) : "***" }}
              </p>
              <app-svg
                (click)="toggleIcon()"
                textClass=""
                src="assets/svgs/{{
                  isIconClicked ? 'eye-svgrepo.svg' : 'eye-closed.svg'
                }}"
                customClass="mt-[-3px] flex items-center cursor-pointer"
                label="title_goes_here"
                [stretch]="false"
                width="24"
                height="24"
                stroke="#fff"
              ></app-svg>
            </div>
          </div>
        </div>
        <!-- <div *ngIf="userData?.siteUsersID && !userWalletAmmount?.isSuccess">
          <app-btn-one link="/woqode-tag" text="popup.Register" textClass="font-Cairo-Regular text-base py-0.5"
            seoDesc="Text about the button" svg="assets/svgs/arrow.svg" svgClass="rotate-[270deg]"></app-btn-one>
        </div> -->
      </div>
    </div>
  </nav>
  <nav *ngIf="isDataReady" class="max-w-large-desktop mx-auto">
    <div class="px-10 mx-auto lg-custom:flex lg-custom:items-center">
      <div
        class="hidden lg-custom:flex flex-col lg-custom:flex-row mt-3 lg-custom:mt-0 gap-[30px] ltr:xl:pl-[175px] rtl:xl:pr-[175px] ltr:lg-custom:pl-[171px] rtl:lg-custom:pr-[171px] min-h-[47.5px] lg-custom:flex-wrap lg-custom:gap-y-0"
        id="main-menu"
        *ngIf="pageType && lang"
        [ngClass]="menuItems?.[pageType]?.[lang].length <= 6 ? 'gap-[83px]':'gap-[30px]'"
      >
        <app-menu-item
          *ngFor="let menuItem of menuItems?.[pageType]?.[lang]; let i = index"
          [data]="menuItem"
          [id]="'menu-item-' + i"
          [isStickyEnabled]="isStickyEnabled"
          (closeMobileMenu)="closeMobileMenu($event)"
          [pageType]="pageType"
          [promotionList]="promotionList"
        ></app-menu-item>
      </div>

      <div
        class="hidden lg-custom:flex flex-col lg-custom:flex-row ltr:lg-custom:ml-auto rtl:lg-custom:mr-auto mt-3 lg-custom:mt-0"
        id="navbar-collapse3"
      >
        <button
          type="button"
          class="button-wraper flex justify-center items-center relative float-left z-10 text-white tracking-[-0.5px] font-Poppins-Light text-sm -mt-[22px] w-[24px] h-[24px] outline-none"
          data-element-scale="1.5"
          (click)="closeMobileMenu(); isSearchModal = true"
        >
          <div class="button-wraper-inner outline-none">
            <app-svg
              src="assets/svgs/search.svg"
              label="title_goas_here"
              [stretch]="false"
              width="24"
              height="24"
            ></app-svg>
          </div>
        </button>
      </div>
    </div>
  </nav>
</header>

<ng-template #linkContent let-link="link">
  <img
    *ngIf="link.icon && link.icon != '00000000-0000-0000-0000-000000000000'"
    [src]="link.icon | imageSource"
    alt=""
    width="17"
    height="17"
    class="w-[17px] h-[17px]"
  />
  <span
    class="tracking-[-0.5px] text-white font-Poppins-Light text-sm text-with-contact_us flex-1"
    style="text-shadow: 4px 4px 10px grey"
    [innerHTML]="link.title[lang] | htmlSanitizer"
  ></span>
</ng-template>

<app-modal
  [template]="modalTemplatePlaceholder3"
  [isModalEnabled]="isSearchModal"
  *ngIf="isSearchModal && isDataReady"
  (closeModalByKeyboard)="closeSearchModal($event)"
  modalClasses="top-[20vh] h-full bottom-[unset] w-[90%] max-w-[1150px]"
>
  <ng-template #modalTemplatePlaceholder3>
    <div>
      <app-search-header
        *ngIf="isSearchModal"
        [isEnabled]="isSearchModal"
        [lang]="lang"
        [pageType]="pageType"
        (closeSearchModal)="closeSearchModal($event)"
      ></app-search-header>
    </div>
  </ng-template>
</app-modal>

<app-modal
  [template]="modalTemplateLogin"
  *ngIf="isLoginModalEnabled"
  [isModalEnabled]="isLoginModalEnabled"
  (closeModalByKeyboard)="closeLoginModal()"
  [modalClasses]="'w-[90%] ' + (loginCarousel?.backgroundIMG?.[lang].length > 0 ? 'max-w-[750px]' : 'max-w-[371px]')"
>
  <ng-template #modalTemplateLogin>
    <div class="bg-white rounded-[5px] relative flex flex-col lg:flex-row min-h-[434px]">
      <div class="modal-header">
        <button
          type="button"
          class="absolute ltr:right-[22px] rtl:left-[22px] top-6 outline-0"
          (click)="closeLoginModal()"
        >
          <app-svg
            src="assets/svgs/close.svg"
            customClass="align-text-top"
            label="title_goas_here"
            [stretch]="false"
            width="16"
            fill="#000000"
          ></app-svg>
        </button>
      </div>
      <div *ngIf="loginCarousel?.backgroundIMG?.[lang].length > 0" class="w-full lg-custom:w-1/2 half-login half-login-modal">
        <app-header-carousel 
          [slidesStore]="loginCarousel?.backgroundIMG?.[lang]"
        ></app-header-carousel>
      </div>
      <div
  class="px-8 py-4 flex flex-col flex-1"
  [ngClass]="loginCarousel?.backgroundIMG?.[lang].length > 0 ? 'lg-custom:w-1/2 half-login' : 'w-full'">

        <ng-container *ngIf="isLoadingEnabled">
          <app-loader-two class="h-full"></app-loader-two>
        </ng-container>
        <ng-container *ngIf="!isLoadingEnabled">
          <div >
            <button
              type="button"
              class="absolute ltr:right-[22px] rtl:left-[22px] top-6 outline-0"
              (click)="closeLoginModal()"
            >
              <app-svg
                src="assets/svgs/close.svg"
                customClass="align-text-top"
                label="title_goas_here"
                [stretch]="false"
                width="16"
                fill="#000000"
              ></app-svg>
            </button>
          </div>
          <h1 class="mb-7 text-lg font-Poppins-Medium font-[600] mt-[70px]">
            {{ "SIGN_IN.SIGN_IN_WOQOD" | translate }}
          </h1>
          <ng-container>
            <form #form="ngForm" novalidate (ngSubmit)="btnDisabled ? null : onSubmitLogin(form)" class="my-auto mt-0">
              <div
                *ngIf="isLoginByPhoneNumberEnabled"
                class="relative"
                 [class.error]="
  (sendOTPFormSubmitted &&
    !form?.controls?.mobileNumber?.valid &&
    !isSentOtp) || errorMsg
"
              >
                <span class="absolute text-[#221E20] text-sm font-Poppins-Light leading-[21px] left-[81px] top-5" style="unicode-bidi: plaintext;">+974 |</span>
    
                <input
                  class="appearance-none border border-[#cfcfcf] rounded w-full p-[19px] text-[#221E20] text-sm font-Poppins-Light leading-[21px] focus:outline-none focus:border-blue-500 pl-[124px]"
                  id="mobileNumber"
                  name="mobileNumber"
                  [(ngModel)]="mobileNumber"
                  pattern="^[3567][0-9]{7}$"
                  required
                  [class.error]="
  (sendOTPFormSubmitted &&
    !form?.controls?.mobileNumber?.valid &&
    !isSentOtp) || errorMsg
"
                    [value]="isSentOtp ? maskMobileNumber(mobileNumber) : mobileNumber"
                  type="tel"
                  placeholder="5523 3232"
                  maxlength="8"
                  minlength="8"
                  onlyNumbers [onlyNumbersAllowDash]="false" [onlyNumbersAllowPlus]="false"
                  [class.disabled-ele]="isSentOtp"
                />
                <div
                  class="absolute left-6 top-0 bottom-0 my-auto flex items-center"
                >
                  <!-- <div class=" bg-red-600 w-9 h-5 rounded-md"></div> -->
  
                  <img src="assets/images/qatar.png" class="w-8 h-auto" />
                  
                </div>
                <div
                  class="absolute right-6 top-0 bottom-0 my-auto flex items-center cursor-pointer z-10"
                >
                  <!-- <div class=" bg-red-600 w-9 h-5 rounded-md"></div> -->
  
                   <span 
                *ngIf="isSendOTPEnabled || errorMsg">
                <app-svg (click)="againsteps()" src="assets/svgs/close.svg" customClass=""
                        label="title_goes_here" [stretch]="false" width="16" height="16" fill="#000"></app-svg></span
              >
                  
                </div>
                
                <label
                  class="absolute -top-1.5 ltr:left-3 rtl:right-3 -mt-2 text-[#717171] text-[13px] leading-[29px] font-Poppins-Light duration-300 origin-0 bg-white px-1"
                  for="Mobile Number"
                  >{{ "SIGN_IN.ENTER_MOBILE_NUMBER" | translate }}</label
                >
              </div>
              <span
                *ngIf="
                  !form?.controls?.mobileNumber?.valid && mobileNumber && !isSentOtp
                "
                class="block text-[#e83d3d] mt-0.5 ltr:text-left rtl:text-right ltr:text-sm rtl:text-xs font-Noto-Sans-Regular"
                >{{ "ERRORS.LOGIN_MOBILE_NUMBER" | translate }}</span
              >
             
             
  
              <div
                *ngIf="!isLoginByPhoneNumberEnabled"
                class="relative"
                [class.error-input]="
                  sendOTPFormSubmitted && !form?.controls?.email?.valid
                "
              >
                <input
                  class="appearance-none border border-[#E0E0E0] rounded w-full p-[19px] text-[#221E20] text-sm font-Poppins-Light leading-[21px] focus:outline-none focus:border-blue-500"
                  id="email"
                  name="email"
                  [(ngModel)]="email"
                  [class.error]="
                    (sendOTPFormSubmitted &&
                      !form?.controls?.email?.valid) ||
                    errorMsg
                  "
                  required
                  email
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  type="email"
                  placeholder="{{ 'SIGN_IN.Enter_Email_Address' | translate }}"
                  maxlength="50"
                />

                <label
                  class="absolute -top-1.5 ltr:left-3 rtl:right-3 -mt-2 text-[#717171] text-[13px] leading-[29px] font-Poppins-Light duration-300 origin-0 bg-white px-1"
                  for="Mobile Number"
                  >{{ "SIGN_IN.Email_Address" | translate }}</label
                >
                <span
                  *ngIf="
                    sendOTPFormSubmitted &&
                    !form?.controls?.email?.valid &&
                    email !== ''
                  "
                  class="block text-[#e83d3d] mt-0.5 ltr:text-right rtl:text-left ltr:text-sm rtl:text-xs font-Noto-Sans-Regular"
                  >{{ "ERRORS.Email" | translate }}</span
                >
              </div>
              <span
              class="block text-[#e83d3d] mt-0.5 ltr:text-left rtl:text-right ltr:text-sm rtl:text-xs font-Noto-Sans-Regular"
              *ngIf="errorMsg"
              >{{ errorMsg?.[lang] }}</span
            >
              <div *ngIf="isSendOTPEnabled" class="mt-2">
                <p
                  (click)="resendPin()"
                  class="ltr:text-right rtl:text-left font-Poppins-Light text-xs text-[#E73C3E]"
                  [class.resendOTP]="isOTPCounterEnd"
                >
                  <ng-container *ngIf="!isOTPCounterEnd">
                    {{ "SIGN_IN.RESEND_IN" | translate }}
                    <app-count-down-timer
                      #otpCounter
                      [initialTime]="settings.loginOTPTimerDuration / 60"
                      (onCounterEnd)="onOTPCounterEnd()"
                      [hidden]="isOTPCounterEnd"
                    ></app-count-down-timer>
                  </ng-container>
                  <ng-container *ngIf="isOTPCounterEnd">
                    {{'Resend_Code' | translate}}
                  </ng-container>
                </p>
  
                <div *ngIf="isSendOTPEnabled" class="relative mt-4">
                  <input
                    class="appearance-none border border-[#E0E0E0] rounded w-full p-[19px] text-[#221E20] text-sm font-Poppins-Light leading-[21px] focus:outline-none focus:border-blue-500"
                    id="otp"
                    name="otp"
                    [(ngModel)]="otp"
                    required
                    onlyNumbers [onlyNumbersAllowDash]="false" [onlyNumbersAllowPlus]="false"
                    [class.error]="!form?.controls?.otp?.valid"
                    type="text"
                    placeholder="{{ 'SIGN_IN.Verification_Code' | translate }}"
                    minlength="6"
                    maxlength="6"
                  />
                  <label
                    class="absolute -top-1.5 ltr:left-3 rtl:right-3 -mt-2 text-[#717171] text-[13px] leading-[29px] font-Poppins-Light duration-300 origin-0 bg-white px-1"
                    for="Mobile Number"
                    >{{ "SIGN_IN.Enter_Verification_Code" | translate }}</label
                  >
                </div>
              <span
              class="block text-[#e83d3d] mt-0.5 ltr:text-left rtl:text-right ltr:text-sm rtl:text-xs font-Noto-Sans-Regular"
              *ngIf="errorMsgOTP"
              >{{ errorMsgOTP?.[lang] }}</span
            >                
              </div>
              <!-- <div *ngIf="!isLoginByPhoneNumberEnabled">
                <span *ngIf="sendOTPFormSubmitted && !form?.controls?.email?.valid"
                  class="block text-[#e83d3d] mt-0.5 ltr:text-sm rtl:text-xs font-Noto-Sans-Regular">{{'ERRORS.THIS_FIELD_IS_REQUIRED'
                  |translate}}</span>
                <span *ngIf="errorMsg"
                  class="block text-[#e83d3d] mt-0.5 ltr:text-sm rtl:text-xs font-Noto-Sans-Regular">{{errorMsg}}</span>
              </div> -->
  
              <!-- bg-gray-400 -->
              <button
                *ngIf="!isSendOTPEnabled"
                type="submit"
                class="bg-[#009933] special-btn text-white text-center w-full py-3 px-4 mt-4 rounded-md transition-all outline-0 font-Poppins-Light"
                [class.disabled-ele]="
                  isLoginByPhoneNumberEnabled
                    ? !form?.controls?.mobileNumber?.valid
                    : !form?.controls?.email?.valid
                "
              >
                {{ "SIGN_IN.Send_OTP" | translate }}
              </button>
              <div *ngIf="isSendOTPEnabled" class="mt-6 w-fit mx-auto">
                <button
                  type="button"
                  class="bg-[#009933] text-white px-6 py-2 rounded-md w-full special-btn"
                  (click)="verifyOTP(form)"
                  [class.disabled-ele]="!form?.controls?.otp?.valid"
                >
                  {{ "SIGN_IN.LOG_IN" | translate }}
                </button>
              </div>
            </form>
            <!-- <div class="relative flex justify-center items-center my-4">
              <div class="bg-[#c1c7e3] h-px w-1/2 absolute inset-0 m-auto"></div>
              <span
                class="px-4 bg-white text-center text-[#c1c7e3] relative z-[10] font-Poppins-Light"
                >{{ "SIGN_IN.or" | translate }}</span
              >
            </div> -->
            <!-- <button
              class="underline text-[#003399] text-center block mx-auto font-Poppins-Medium font-[600] text-sm mb-2"
              type="button"
              (click)="switchLoginType()"
            >
              {{
                (isLoginByPhoneNumberEnabled
                  ? "SIGN_IN.Login_by_Email"
                  : "SIGN_IN.Login_by_mobile_number"
                ) | translate
              }}
            </button> -->
          </ng-container>
          <p class="text-[#9da4b0] mt-auto font-Poppins-Light text-xs pt-4">
            {{ "SIGN_IN.Protected_by_reCAPTCHA_and_subject_to_the" | translate }}
            <a class="text-[#009933] underline cursor-pointer" [routerLink]="'/pages/privacy_notice' | routeLocalization" target="_blank">{{
              "SIGN_IN.Woqod_Privacy_Policy" | translate
            }}</a>
            {{ "SIGN_IN.and" | translate }}
            <a class="text-[#009933] underline cursor-pointer" [routerLink]="'/pages/woqodtermsandconditions' | routeLocalization" target="_blank"
              >{{ "SIGN_IN.Terms_of_Service" | translate }}.</a
            >
          </p>
        </ng-container>
        
      </div>
    </div>
  </ng-template>
</app-modal>

<app-modal
  [template]="modalTemplatePlaceholder1"
  [isModalEnabled]="isModalEnabled"
  (closeModalByKeyboard)="isModalEnabled = false"
  modalClasses="w-[90%] max-w-[912px]"
>
  <ng-template #modalTemplatePlaceholder1>
    <div
      class="bg-white pt-[65px] rounded-[5px] relative px-6 pb-6 lg-custom:px-1 lg-custom:pb-[52px]"
    >
      <div class="modal-header">
        <button
          type="button"
          class="absolute ltr:right-[22px] rtl:left-[22px] top-6 outline-0"
          (click)="isModalEnabled = false"
        >
          <app-svg
            src="assets/svgs/close.svg"
            customClass="align-text-top"
            label="title_goas_here"
            [stretch]="false"
            width="16"
            fill="#000000"
          ></app-svg>
        </button>
      </div>
      <div class="modal-body relative overflow-x-auto px-0 lg-custom:px-[42px]">
        <div class="flex flex-col lg-custom:flex-row gap-[84px] pb-[77px]">
          <div class="flex flex-col w-full lg-custom:w-1/2">
            <app-svg
              src="assets/svgs/wallet-header.svg"
              customClass="align-text-top"
              label="title_goas_here"
              [stretch]="false"
              width="40"
              height="40"
              fill="#000000"
            ></app-svg>
            <div class="flex flex-row gap-3 items-center">
              <p class="font-semibold text-[30px]">
                {{ isIconClicked2 ? (formatAmount(userWalletAmmount?.result || 0) || 0) : "XXXX.XX" }}
                <span class="text-[10px]">{{
                  "CURRENCIES.QR" | translate
                }}</span>
              </p>
              <app-svg
                (click)="toggleIcon2()"
                textClass=""
                src="assets/svgs/{{
                  isIconClicked2 ? 'eye-closed.svg' : 'eye-svgrepo.svg'
                }}"
                customClass="mt-[-3px] cursor-pointer"
                label="title_goes_here"
                [stretch]="false"
                width="24"
                height="24"
                stroke="#000"
              ></app-svg>
            </div>
            <p class="text-sm font-Poppins-Light pb-[38px]">
              {{ "DASHBOARD.CURRENT" | translate }}
            </p>
            <p class="text-xl leading-[24px] font-semibold text-[#003399] pb-1">
              {{ "DASHBOARD.TOPUP" | translate }}
            </p>
          <p *ngIf="!topUpSetting.min && !topUpSetting.max" class="text-xs text-[#77767A] font-Poppins-Light">
              {{ "DASHBOARD.NOMINALSHORT" | translate }}
          </p>
          <p *ngIf="topUpSetting.min && topUpSetting.max" class="text-xs text-[#77767A] font-Poppins-Light">
              {{ "DASHBOARD.NOMINAL" | translate: {min: formatAmount(topUpSetting.min), max: formatAmount(topUpSetting.max)} }}
          </p>          
            <div
              class="flex flex-row gap-3 py-3 w-full lg-custom:w-[335px] pb-[52px]"
            >
              <form #topupform="ngForm" class="relative w-full" novalidate>
                <div class="relative">
                  <span
                    class="absolute inset-y-0 ltr:left-0 rtl:right-0 flex items-center ltr:pl-[18px] rtl:pr-[18px] text-[#A2A2A2] text-sm leading-[30px] font-Poppins-Light"
                    >{{ "CURRENCIES.QAR" | translate }}</span
                  >
                  <input
                    type="text"
                    name="inputValue"
                    [(ngModel)]="inputValue"
                    onlyNumbers
                    id="inputValue"
                    required
                    [class.error]="
                      (inputValue && +inputValue < topUpSetting.min) ||
                      +inputValue > topUpSetting.max ||
                      (isSubmitted && !topupform?.controls?.inputValue?.valid)
                    "
                    class="ltr:pl-[51px] rtl:pr-[51px] w-full bg-white text-[#111111] border border-[#ECECEE] text-xl leading-[30px] rounded py-3 px-3 font-semibold"
                    placeholder="8000"
                    [onlyNumbersAllowDash]="false"
                  />
                </div>
                <span
                  *ngIf="inputValue && +inputValue < topUpSetting.min"
                  class="block text-[#e83d3d] mt-0.5 ltr:text-right rtl:text-left ltr:text-sm rtl:text-xs font-Noto-Sans-Regular"
                >
                  {{ "ERRORS.VALUE_TOO_LOW" | translate }}
                </span>
                <span
                  *ngIf="+inputValue > topUpSetting.max"
                  class="block text-[#e83d3d] mt-0.5 ltr:text-right rtl:text-left ltr:text-sm rtl:text-xs font-Noto-Sans-Regular"
                >
                  {{ "ERRORS.VALUE_EXCEEDS_LIMIT" | translate }}
                </span>
                <span
                  *ngIf="isSubmitted && !topupform?.controls?.inputValue?.valid"
                  class="block text-[#e83d3d] mt-0.5 ltr:text-right rtl:text-left ltr:text-sm rtl:text-xs font-Noto-Sans-Regular"
                  >{{ "ERRORS.THIS_FIELD_IS_REQUIRED" | translate }}</span
                >
              </form>
            </div>
            <p></p>
            <app-checkbox
              [data]="checkBox1"
              [isErrorEnabled]="isSubmitted && !checkBox1.value"
              [lang]="lang"
              (onChange)="checkBox1.value = $event"
            ></app-checkbox>
          </div>
          <div class="flex flex-col my-auto items-center gap-3">
            <p
              class="font-semibold text-xl leading-[24px] text-[#003399] w-full"
            >
              {{ "DASHBOARD.INSTANT" | translate }}
            </p>
            <div class="flex flex-row gap-3 flex-wrap">
              <button
                *ngFor="let amount of userWalletAmount; let i = index"
                (click)="updateInput(amount)"
                [class.clicked]="amount === inputValue"
                class="bg-[#ECECEE] rounded-[20px] font-semibold leading-[30px] text-[#111111] px-[15px] py-[10px]"
              >
                {{ formatAmount(amount) }}
              </button>
            <button
              (click)="otherAmount()"
              class="bg-[#ECECEE] rounded-[20px] font-semibold leading-[30px] text-[#111111] px-[15px] py-[10px]"
            >
              {{ 'Other Amount' | translate }}
            </button>                          
            </div>
          </div>
        </div>
        <div class="w-full flex justify-center lg:justify-end">
          <!-- <a [href]=" '/payment-of-wallet' | routeLocalization "
            class="bg-[#009933] px-[34px] py-1 text-lg font-Cairo-Regular text-white rounded-[5px]">{{'DASHBOARD.PAYMENT'
            | translate}}</a> -->
          <app-btn-one
            textClass="text-base"
            (onClick)="toPayment()"
            text="DASHBOARD.PAYMENT"
            seoDesc="DASHBOARD.PAYMENT"
            svg="assets/svgs/arrow.svg"
            svgClass="rotate-[270deg]"
          ></app-btn-one>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>



<app-recaptch #recaptchEle (onSuccess)="onRecaptchSuccess($event)"></app-recaptch>